import { Shark, PreactRenderer, SwimWay } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import $ from "jquery";

import User from "./models/User";

import dashboardView from "./views/dashboard/dashboardView";
import loginView from "./views/login/loginView";
import passwordResetView from "./views/passwordRecovery/passwordResetView";

// import "popper.js";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "@yaireo/tagify/dist/tagify.css";
import "./css/custom.css";

const needLogin = () => {
	Shark.openPage(loginView);
};

const startUp = () => {
	const apiURL = process.env.API_URL;
	const cdnURL = process.env.CDN_URL;
	const envMode = process.env.NODE_ENV;
	const envType = process.env.SYSTEM_ENV;

	if (envMode === "production" && envType === "production") {
		document.body.oncontextmenu = () => { return false; };
	}

	NousCore.api.settings.commonEndPointBase = apiURL + "/";
	Shark.traceLevel = Shark.TRACE_INFO;

	Shark.init({
		// enableJawStoreAutoRender: true,
		enableMainStoreAutoRender: true,
		enableSmartModelSetUpdatesView: true,
		routingMethod: "url",
		templateRenderer: new PreactRenderer(),
	});

	const router = new SwimWay(Shark.settings.routingMethod);
	const numberFormatter = new Intl.NumberFormat("it-IT", {maximumFractionDigits: 2});

	Shark.set({
		apiURL,
		apiV2URL: apiURL + "/v2",
		appBuildDate: __BUILD_DATE__,
		appVersion: __VERSION__,
		cdnURL,
		formatDateISO: "YYYY-MM-DD",
		isTestEnv: process.env.SYSTEM_ENV === "staging",
		numberFormatter,
		router,
	});

	$(NousCore.api).on("sessionUserRetrieved", function () {
		if (NousCore.api.sessionUserData) {
			console.log(NousCore.api.sessionUserData);
			const currUser = Shark.getInstance("User", NousCore.api.sessionUserData);
			Shark.set({currUser});
			
			const requestedView = Shark.$store.router.getRequestedViewFromLocation();
			
			if (requestedView === "") {
				Shark.openPage(dashboardView);
			}
			else {
				// pushManager.registerIfYouCan();
				Shark.openPage(requestedView, {urlSearchParams: ""});
			}
		}
		else {
			needLogin();
		}
	});

	$(NousCore.api).on("sessionValidated", function () {
		if (NousCore.api.hasValidSession) {
			NousCore.api.getSessionUser();
		}
		else {
			needLogin();
		}
	});

	const urlParams = new URLSearchParams(document.location.search);
	if (urlParams.has("k")) {
		const currUser = new User();
		const tempKey = urlParams.get("k");
		const guid = urlParams.get("g");

		currUser.set({
			guid,
			tempKey,
		});
		
		Shark.set({
			confirmSent: false,
			currUser,
			tempKey,
			__tempKeyIsValid: tempKey !== null,
		});
		// Shark.openPage(passwordResetView);
		Shark.openPage(passwordResetView, {urlSearchParams: null});
	}
	else {

		if (localStorage.getItem("preserveLogin") === "true") {
			NousCore.api.validateSession();
		}
		else {
			needLogin();
		}
	}
};

startUp();
